import React from 'react';
import { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } from '@apollo/client';
import ReactOnRails from 'react-on-rails';
import AdvisorMapBacklogContainer from '../containers/AdvisorMapBacklogContainer';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';

const client = new ApolloClient({
  link: new HttpLink({
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': ReactOnRails.authenticityToken(),
    },
  }),
  cache: new InMemoryCache(),
});

const AdvisorMapBacklogPage = (props) => {
  return (
    <ApolloProvider client={client}>
      <SuccessionThemeProvider company={props?.company} user={props?.current_user}>
        <AdvisorMapBacklogContainer {...props} />
      </SuccessionThemeProvider>
    </ApolloProvider>
  );
};

export default AdvisorMapBacklogPage;


